import { Injectable } from '@angular/core';
import { TokenService } from './token.service';

@Injectable({
  providedIn: 'root',
})
export class ClaimsService {
  public constructor(private tokenService: TokenService) { }

  get getDisplayName() {
    return this.tokenService.decodedToken ? this.tokenService.decodedToken.DisplayName : null
  }

  get getUserName() {
    return this.tokenService.decodedToken ? this.tokenService.decodedToken.Name : null
  }

  get getUserId() {
    return this.tokenService.decodedToken ? this.tokenService.decodedToken.UserId: null
  }

  get getUserRole() {
    switch (this.tokenService.decodedToken.Role) {
      case 'Admin':
        return 2;
        case 'Moderator':
          return 1;
      case 'User':
          return 0;
          default:
            return 0;
    }
  }
}
